import React from 'react';
import {
    Menu,
    Box,
    Typography,
    MenuItem,
    Divider,
    Button,
    Avatar,
    Chip,
    FormControl,
    Select,
} from '@mui/material';

const NotificationMenu = ({ anchorEl, onClose }) => {
    const open = Boolean(anchorEl);

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: { width: 360, borderRadius: 3, p: 2 }
            }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold">Todas las notificaciones</Typography>
                <Chip label="01" size="small" color="warning" />
            </Box>

            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                <Select value="all" displayEmpty>
                    <MenuItem value="all">Todas las notificaciones</MenuItem>
                </Select>
            </FormControl>

            <Divider sx={{ mb: 1 }} />

            {/* Notificación 1 */}
            <MenuItem alignItems="flex-start" sx={{ flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar src="/static/images/avatar/1.jpg" sx={{ width: 32, height: 32 }} />
                    <Box>
                        <Typography fontWeight="bold" fontSize={14}>John Doe</Typography>
                        <Typography variant="caption">Es un hecho ampliamente conocido...</Typography>
                        <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                            <Chip size="small" label="No leído" color="error" />
                            <Chip size="small" label="Nuevo" color="warning" />
                        </Box>
                    </Box>
                </Box>
            </MenuItem>

            {/* Notificación 2 */}
            <MenuItem alignItems="flex-start" sx={{ flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: 'lightgreen' }}>S</Avatar>
                    <Box>
                        <Typography fontWeight="bold" fontSize={14}>Verificación de tienda completada</Typography>
                        <Typography variant="caption">Hemos recibido correctamente tu solicitud.</Typography>
                        <Chip size="small" label="No leído" color="error" sx={{ mt: 0.5 }} />
                    </Box>
                </Box>
            </MenuItem>

            {/* Notificación 3 */}
            <MenuItem alignItems="flex-start" sx={{ flexDirection: 'column', alignItems: 'start' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Avatar sx={{ width: 32, height: 32, bgcolor: 'lightblue' }}>M</Avatar>
                    <Box>
                        <Typography fontWeight="bold" fontSize={14}>Revisa tu correo</Typography>
                        <Typography variant="caption">¡Todo listo! Ahora revisa tu bandeja de entrada...</Typography>
                        <Button size="small" variant="contained" sx={{ mt: 0.5 }}>
                            Correo
                        </Button>
                    </Box>
                </Box>
            </MenuItem>

            <Divider sx={{ my: 1 }} />
            <Button fullWidth>Ver todas</Button>
        </Menu>
    );
};

export default NotificationMenu;
